module.exports = __webpack_public_path__ + "img/幸福蓉漂.4a90e662.png";